import React, { memo, useMemo } from 'react';
import { View } from 'react-native';
import { useAppSelector } from 'store/hooks';
import Text from 'design-system/Text';
import ProgressCard from 'features/invest/components/InvestOnboardingFunnel/ProgressCard';
import { selectPotIdPotInfoMap } from 'features/pots/reducers/selectors';
import { getPotDisplayName } from 'features/pots/utils';
import { formatDateForItem } from 'utils';
import AutosaveDestination from './AutosaveDestination';
const ArrivingInEmmaInfoCard = ({ potName, completed, isActiveStep, completedDate, savingsPlanInfo, }) => {
    const potIdPotInfoMap = useAppSelector(selectPotIdPotInfoMap);
    const title = useMemo(() => {
        if (potName) {
            return completed ? `Moved to ${getPotDisplayName(potName)}` : `Moving to ${getPotDisplayName(potName)}`;
        }
        return completed ? 'Moved to Pots' : 'Moving to Pots';
    }, [completed, potName]);
    const subTitle = useMemo(() => {
        if (potName) {
            return completed
                ? `The money has been added to your selected Pot.`
                : `We’ll move the money to your selected Pot.`;
        }
        return completed ? 'The money has been added to your Pots.' : 'We’ll move the money to your selected Pots.';
    }, [completed, potName]);
    return (<View testID="arrivingInEmmaView">
      <ProgressCard lightBg lastItem title={title} noTextDecoration alwaysShowChildren alwaysShowTimeline completed={completed} isActiveStep={isActiveStep} timeInfo={completedDate ? formatDateForItem(new Date(completedDate)) : undefined}>
        <Text TextThin-14 Secondary>
          {subTitle}
        </Text>
        {!potName && (<>
            {savingsPlanInfo.destinations.map((destination) => (<AutosaveDestination key={destination.potId} destination={destination} potIdPotInfoMap={potIdPotInfoMap}/>))}
          </>)}
      </ProgressCard>
    </View>);
};
export default memo(ArrivingInEmmaInfoCard);
